export const FALLBACK_RESOURCE_INVOICE_CURRENCY = "USD"

export const RESOURCE_DOCUMENTS_BUCKET = "resource_docs"

export const QUERYABLE_RESOURCE_STATUSES = [
  "pending",
  "active",
  "inactive",
] as const

export type QueryableResourceStatus =
  (typeof QUERYABLE_RESOURCE_STATUSES)[number]

export const QUERYABLE_RESOURCE_INVOICE_STATUSES = [
  "draft",
  "submitted",
  "approved",
  "rejected",
  "paid",
] as const

export type QueryableResourceInvoiceStatus =
  (typeof QUERYABLE_RESOURCE_INVOICE_STATUSES)[number]

/**
 * Statuses that are visible to admin users
 * We don't want to show draft invoices in this list
 */
export const ADMIN_VIEWABLE_RESOURCE_INVOICE_STATUSES = [
  "submitted",
  "approved",
  "rejected",
  "paid",
] as const

export type AdminViewableResourceInvoiceStatus =
  (typeof ADMIN_VIEWABLE_RESOURCE_INVOICE_STATUSES)[number]
